























import {
  Vue, Component, Prop, Emit,
} from 'vue-property-decorator';
import MainButton from '@/shared/buttons/main-button.component.vue';

@Component({
  components: {
    MainButton,
  },
})
export default class ActionButton extends Vue {
  @Prop({
    required: false,
  })
  options!: any;

  @Prop() disabled!: boolean;

  @Emit('click')
  click(): void {}
}
